export default {"src":"/_next/static/media/twitter_icon_white.ec498ef2.svg","height":18,"width":23,"blurWidth":0,"blurHeight":0};